import React from 'react';
import { BookOpen, ShoppingBasket } from 'lucide-react';


const EmployeeOrganizationTools = ({
  settings = {},
  onOpenShoppingList,
  onOpenRecipes,
}) => (
  <>
    {settings.is_shopping_list_enabled === true && (
      <button
        type="button"
        data-testid="employee-shopping-list"
        onClick={onOpenShoppingList}
        className="inline-flex items-center gap-2 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100"
      >
        <ShoppingBasket size={18} className="shrink-0" aria-hidden="true" />
        <span>Einkaufsliste</span>
      </button>
    )}
    {settings.is_recipe_library_enabled === true && (
      <button
        type="button"
        data-testid="employee-recipes"
        onClick={onOpenRecipes}
        className="inline-flex items-center gap-2 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100"
      >
        <BookOpen size={18} className="shrink-0" aria-hidden="true" />
        <span>Rezepte</span>
      </button>
    )}
  </>
);

export default EmployeeOrganizationTools;
